import { Router } from "@angular/router";

export function TypeUser(type: string, url: string): boolean {
    // Verificar el tipo de usuario que está ingresando.
    const userCodi = localStorage.getItem('user_code');
    const userJson = userCodi ? JSON.parse(atob(userCodi)) : null;

    if (userJson && (type === userJson.user_type) && url.includes(type)) {
        return true;
    }

    return false;
}